import {
  ClientOptionsContext
} from "./chunk-4CM6CARW.mjs";

// src/provider.tsx
import { jsx } from "react/jsx-runtime";
function NavermapsProvider({
  children,
  ...clientOptions
}) {
  return /* @__PURE__ */ jsx(ClientOptionsContext.Provider, {
    value: clientOptions,
    children
  });
}

export {
  NavermapsProvider
};
//# sourceMappingURL=chunk-RNJMH53Z.mjs.map